import styles from "./buyPoints.module.css";

const bonusPointsStyles = {
    container: `flex flex-col gap-6 items-center justify-center rounded-[8px] bg-white p-[20px] pt-[18px] w-full text-black relative
                screen-500:w-[450px] ${styles.container}
    `,
    closeButtonContainer: `absolute top-[5px] right-2`,
    dataContainer: ` flex flex-col gap-[20px] w-full`,
    subHeading: `text-[25px] leading-[20px] text-left font-Suisse capitalize`,
    heading: `text-[27px] text-center font-Suisse capitalize ${styles.heading}`,
    points_img:`w-full h-auto max-w-[46px] ${styles.points_img}`,
    noteText: `text-[11px] font-[500] text-primaryHeading`,
    formContainer: `flex flex-col gap-[22px]`,
    buttonContainer: `flex sm:flex-row flex-col gap-2 sm:gap-3 w-full`,
    button: `!px-[27px] !py-[5px] w-full max-w-[50%] ${styles.button}`,
}

export { bonusPointsStyles }